import React from 'react'
import { withTranslation as translate } from 'react-i18next'
import SelectDropdown from './select-dropdown-guests.jsx'
import { convertRoomQueryToGuestPickerData } from "../services/utils";

const defaultRoomData = {
  room: 1,
  nr_adults: 2,
  children: []
}

class CounterFieldNrRooms extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      active: false,
      // roomsData: [defaultRoomData],
      roomsData: (this.props.router && 
        this.props.router.location && 
        this.props.router.location.query && 
        Object.keys(this.props.router.location.query).length !== 0
      ) ? (convertRoomQueryToGuestPickerData(this.props.router.location.query) ?
          convertRoomQueryToGuestPickerData(this.props.router.location.query) : [defaultRoomData]) : [defaultRoomData],
      activeRoomTab: 1,
    }
    this.generateChildrenAges = this.generateChildrenAges.bind(this)
    this.buttonCountHandler = this.buttonCountHandler.bind(this)
    this.renderChildAgeDrpdwn = this.renderChildAgeDrpdwn.bind(this)
    this.displayToggle = this.displayToggle.bind(this)
    this.changeHandler = this.changeHandler.bind(this)
    this.handleRoomPlus = this.handleRoomPlus.bind(this)
    this.handleRoomMinus = this.handleRoomMinus.bind(this)
    this.handleTabClick = this.handleTabClick.bind(this)
    this.allGuestsAmount = this.allGuestsAmount.bind(this)
    this.allGuestsAdultsAmount = this.allGuestsAdultsAmount.bind(this)
    this.allGuestsChildsAmount = this.allGuestsChildsAmount.bind(this)

  }
  componentDidMount() {
    this.handleTabClick(this.state.roomsData.length)
    this.generateChildrenAges()
  }

  componentDidUpdate(){
    if (this.state.active) {
      document.body.onclick = e => {
        // For clicks inside dropdown, no action, otherwise, dismiss
        if (e.target.id==='guestsPickerWrapper' || e.target.className==='guests-button'
            || e.target.className==='drpdwn-wrapper'
            || e.target.className==='guests-picker-counter-wrapper'
            || e.target.className==='guests-picker-button-wrapper'
            || e.target.className==='child-age-drpdwn'
            || e.target.className==='guests-summarize'
            || e.target.className==='room-wrapper-scroller-header'
            || e.target.className==='room-wrapper-header-inner'
        ) {
          return false
        }
        else {
          this.setState({active: false})
        }
      }
    }
  }

  handleRoomPlus(e) {
    e.preventDefault();
    const newState = [...this.state.roomsData, {
      room: this.state.roomsData.length + 1,
      nr_adults: 2,
      children: []
    }]
    this.setState({roomsData: newState})
    this.setState({activeRoomTab: this.state.activeRoomTab + 1})
    // const parent = document.getElementById("roomWrapperScrollerElem");
    // console.log("parent", parent.scrollWidth);
    // console.log("eeee", e);
    // e.scrollRight += 999999999;
    this.props.onChange(newState)
  }

  handleRoomMinus(e) {
    e.preventDefault();
    const newState = this.state.roomsData.filter((roomObj) => roomObj.room !== this.state.roomsData.length)
    this.setState({roomsData: newState})
    this.setState({activeRoomTab: this.state.activeRoomTab - 1})
    this.props.onChange(newState)

  }

  displayToggle(e){
    e.preventDefault()
    this.setState({active: !this.state.active})
  }

  changeHandler(newnNr, selectNr) {
    let selectors = Array.from(document.querySelectorAll('.child-age-drpdwn'))
    let childsWithAge = []
    selectors.map((item, idx) => {
      let age = item.value;
      if ((idx + 1) === selectNr) {
        age = newnNr
      }
      if (!age){
        age = 0;
      }
      childsWithAge.push({child: idx + 1, age: parseInt(age)})
    })
    const newState = this.state.roomsData.map(obj => {
      if (obj.room === this.state.activeRoomTab) {
        return {...obj, children: childsWithAge};
      }
      return obj;
    });
    this.setState({roomsData: newState});
    this.props.onChange(newState)
  }

  allGuestsAmount() {
    let amount = 0;
    this.state.roomsData.forEach((room) => {
      let x = room.nr_adults;
      let y = room.children.length;
      amount = amount + (x + y);
    })
    return amount
  }

  allGuestsAdultsAmount() {
    let amount = 0;
    this.state.roomsData.forEach((room) => {
      amount =  amount + room.nr_adults;
    })
    return amount
  }

  allGuestsChildsAmount() {
    let amount = 0;
    this.state.roomsData.forEach((room) => {
      amount =  amount + room.children.length;
    })
    return amount
  }

  handleTabClick(tabValue) {
    this.setState({activeRoomTab: tabValue})
  }

  buttonCountHandler(e){
    e.preventDefault();
    let operation = e.currentTarget.id
    switch (operation) {
    case 'adultIncrement':
      const newStateAdultInc = this.state.roomsData.map(obj => {
        if (obj.room === this.state.activeRoomTab) {
          return {...obj, nr_adults: obj.nr_adults = obj.nr_adults + 1};
        }
        return obj;
      });
      this.setState({roomsData: newStateAdultInc});
      this.props.onChange(newStateAdultInc)
      break
    case 'adultDecrement':
      const newStateAdultDec = this.state.roomsData.map(obj => {
        if (obj.room === this.state.activeRoomTab) {
          return {...obj, nr_adults: obj.nr_adults = obj.nr_adults - 1};
        }
        return obj;
      });
      this.setState({roomsData: newStateAdultDec});
      this.props.onChange(newStateAdultDec)
      break
    case 'childrenIncrement':
      const newStateChildrenInc = this.state.roomsData.map(obj => {
        if (obj.room === this.state.activeRoomTab) {
          return {...obj, children: [...obj.children, {child: obj.children.length + 1, age: 0}]};
        }
        return obj;
      });
      this.setState({roomsData: newStateChildrenInc});
      this.props.onChange(newStateChildrenInc)
      break
    case 'childrenDecrement':
      const newStateChildrenDec = this.state.roomsData.map(obj => {
        if (obj.room === this.state.activeRoomTab) {
          const newArr = [...obj.children];
          newArr.pop();
          return {...obj, children: newArr};
        }
        return obj;
      });
      this.setState({roomsData: newStateChildrenDec});
      this.props.onChange(newStateChildrenDec)
      break
    default:
      return
    }
  }
  generateChildrenAges(){
    let childrenAges = []
    for (let i = 0; i < 18; i++){
      let age = {
        label: i +' '+this.props.t('years_old'),
        value: i
      }
      childrenAges.push(age)
    }
    this.setState({childrenAges: childrenAges})
  }
  renderChildAgeDrpdwn(rooms){
    let selectors = []
    const currentRoom = rooms.filter((roomsObj) => roomsObj.room === this.state.activeRoomTab);
    const getchilds = (currentRoom && currentRoom[0].children.length > 0) ? currentRoom[0].children : []
    getchilds.forEach((child, i) => {
      selectors.push(<SelectDropdown
        qvalue={child.age}
        selectNr={i + 1}
        key={i}
        placeholder={this.props.t('age_at_check-out')}
        options={this.state.childrenAges}
        className="child-age-drpdwn"
        onChange={this.changeHandler}
      />)
      })
    if (selectors.length > 0) {
      return selectors
    } else {
      return
    }
  }
  render(){
    const _t = this.props.t
    let className = 'guests-picker-wrapper guests-picker-wrapper-mobile'
    this.state.active? className = 'guests-picker-wrapper guests-picker-wrapper-mobile focus-class': 'guests-picker-wrapper guests-picker-wrapper-mobile'
    return (
      <div
        className={className}
        id="guestsPickerWrapper"
      >
        <div className='guests-picker guests-picker-mobile' onClick={this.displayToggle}>
          <div>Guests: {this.allGuestsAmount()}</div>
          {(this.state.roomsData.length > 0) ? 
            <div>Rooms: {this.state.roomsData.length}</div> : null
          }
        </div>
        <div className={this.state.active?'guests-picker-dropdown-block guests-picker-dropdown-block-mobile': 'hide' } id="guestsPickerDropdown">
          <div 
            id="roomWrapperScrollerElem"
            className='room-wrapper-scroller-header'
            style={{display: "flex", padding: "5px", alignItems: "center", overflowX: "scroll", whiteSpace: "nowrap"}}
          >
            {this.state.roomsData.map((roomObj, index) => {
              return (
                (this.state.activeRoomTab === roomObj.room) ?
                <div
                  className='room-wrapper-header-inner'
                  key={index}
                  style={{borderRight: "1px solid gray", padding: "5px 10px", color: "#28b6ff"}}
                >
                  {`Room ${index + 1}`}
                </div> :
                <div
                  className='room-wrapper-header-inner'
                  key={index} onClick={() => this.handleTabClick(roomObj.room)}
                  style={{borderRight: "1px solid gray", padding: "5px 10px", cursor: "pointer"}}
                >
                  {`Room ${index + 1}`}
                </div>
              )
            })}
            <div style={{display: "flex", alignItems: "center", gap: "5px", marginLeft: "5px"}}>
              {(this.state.roomsData.length > 1 && this.state.activeRoomTab !== 1) ?
                <button className="guests-button" onClick={this.handleRoomMinus}>-</button> : null
              }
              <button className="guests-button" onClick={this.handleRoomPlus}>+</button>
            </div>
          </div>

          <div style={{borderBottom: "2px solid gray"}}></div>

          <div className="guests-picker-counter-wrapper">
            <span>{_t('adults')}</span>
            <div className="guests-picker-button-wrapper">
              <button onClick={this.buttonCountHandler} className="guests-button" id="adultDecrement">-</button>
              <span>{
                this.state.roomsData
                  .filter((roomsObj) => roomsObj.room === this.state.activeRoomTab)
                  .map((roomsObj) => roomsObj.nr_adults)[0]
              }</span>
              <button onClick={this.buttonCountHandler} className="guests-button" id="adultIncrement">+</button>
            </div>
          </div>
          <div className="guests-picker-counter-wrapper">
            <span>{_t('children')}</span>
            <div className="guests-picker-button-wrapper">
              <button onClick={this.buttonCountHandler} className="guests-button" id="childrenDecrement">-</button>
              <span>{
                this.state.roomsData
                  .filter((roomsObj) => roomsObj.room === this.state.activeRoomTab)
                  .map((roomsObj) => roomsObj.children.length)[0]
              }</span>
              <button onClick={this.buttonCountHandler} className="guests-button" id="childrenIncrement">+</button>
            </div>
          </div>
          <div className="guests-picker-counter-wrapper">

          </div>
          <div className="drpdwn-wrapper">
            {/* {this.state.roomsData
              .filter((roomsObj) => roomsObj.room === this.state.activeRoomTab)
              .map((roomsObj) => roomsObj.children.length)[0]
              ? <span>{_t("what_are_the_ages_of_the_children_you're_traveling_with")}</span>: null} */}
            {this.renderChildAgeDrpdwn(this.state.roomsData)}
          </div>
          <span className="guests-summarize">{this.allGuestsAdultsAmount()} {_t('adults')}, {this.allGuestsChildsAmount()} {_t('children')} ({this.allGuestsAmount()}) {_t('person')}</span>
        </div>
      </div>
    )
  }
}

export default translate()(CounterFieldNrRooms)
